import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ApexChart from '../../components/Chart';
import DraggableModal from '../../components/DraggableModal';
import { actions, selectors } from '../../store/dux/yield-dux';
import { useGrowers } from '../../hooks/use-growers';

export default function YieldStatsGraph(props) {
  const { field, onClose, year } = props;
  const dispatch = useDispatch();
  const stats = useSelector(selectors.yieldStats);
  const { selectedId: growerId } = useGrowers();

  useEffect(() => {
    dispatch(
      actions.loadYieldStats(growerId, field.aaid, field.harvestedCrop, year),
    );
  }, [dispatch, field, growerId, year]);

  return (
    <DraggableModal
      title={`Yield Stats for ${field.fieldName}`}
      handleClose={onClose}
      isLoading={!stats.chart}
    >
      {stats.chart && (
        <ApexChart
          chartWidth="100%"
          xLabel="Yield"
          yLabel="Acres"
          stats={stats}
        />
      )}
    </DraggableModal>
  );
}
